import {Injectable} from '@angular/core';
import {AppSettings} from '../../../settings/app-settings';
import {Observable} from 'rxjs/Observable';
import {MStore} from '../model/m-store';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class MStoreService {

  constructor(private http: HttpClient) {
  }

  public findAll(): Observable<MStore[]> {
    return this.http.get<MStore[]>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-store/find-all');
  }

  public save(mStore: MStore): Observable<MStore> {
    return this.http.post<MStore>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-store/save', mStore);
  }

  public delete(indexNo: number): Observable<number> {
    return this.http.delete<number>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-store/delete/' + indexNo);
  }

  public findByMBranch(branch: number): Observable<MStore[]> {
    return this.http.get<MStore[]>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-store/find-by-branch/' + branch);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-store/service/m-store.service.ts